import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ReactToPrint from "react-to-print";

const componentRef = React.createRef();

/**Componente donde muestra un modal de la orden de pago
 * por ahora se usa en tramites.js
 * <PagoOrden modalOrden={this.state.modalOrden} change={this.handleClose}/>
 */
class PagoOrden extends React.Component {
  constructor(props) {
    super();
  }

  render() {
    return (
      <Modal isOpen={this.props.modalOrden} modalClassName="modal-message">
        <ModalHeader>
          Orden de pago: {this.props.orden.folio_orden}
          <button type="button"  className="close"  onClick={this.props.change} style={{position: 'fixed', right: '21%'}}>
            <span aria-hidden="true" >&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className={this.props.working ? "" : "hide"}>
            <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
              CARGANDO INFORMACIÓN
            </div>
          </div>

          <div className={this.props.working ? "hide" : ""}>
            <div
              className="row"
              ref={componentRef}
              style={{ background: "white" }}
            >
              {/*Aqui se muestra la orden de pago******************************************************/}
              <form
                style={{
                  marginRight: "13%",
                  marginLeft: "13%",
                  color: "black",
                }}
              >
                <table style={{ width: "100%", tableLayout:"auto" }}>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "left", color: "black" }}>
                          <img
                            src="../assets/Escudo.jpg"
                            width="100"
                            height="100"
                          />
                        </td>
                        <td style={{ textAlign: "right", color: "black" }}>
                          <img
                            src="../assets/1631027847767_Logo IPSA.png"
                            width="200"
                            height="100"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                <h5 style={{ textAlign: "center", margin: "3%" }}>
                  INSTITUTO DE PROTECCIÓN Y SANIDAD AGROPECUARIA DIRECCIÓN DE
                  SALUD ANIMAL DEPARTAMENTO DE REGULACIÓN Y CONTROL DE INSUMOS
                  PECUARIOS
                </h5>
                <p style={{ textAlign: "center", margin: "8%" }}>
                  PROFORMA No. {this.props.orden.folio_orden}
                </p>
                <p>
                  <b>El recibo será elaborado a nombre de </b>
                  {this.props.orden.nombre_cliente}
                </p>
                <p>
                  <b>Por la cantidad de: U$ </b> {this.props.orden.cantidad_num}
                  <b>. En letras: </b>
                  {this.props.orden.cantidad_txt}.
                </p>
                {this.props.orden.cantidad_tex}
                <p>
                  <b>Descripción del servicio: </b> 
                  {/*Si es una orden para establecimiento */}
                  {(this.props.orden.tramite_id === "3")?( this.props.orden.razon_social === "" ?
                  "Pago de alta de " +  this.props.orden.tipo_establecimiento + " con actividad " +this.props.orden.actividad 
                  : "Pago de alta actividad para el establecimiento " + this.props.orden.razon_social + " de tipo " + this.props.orden.tipo_establecimiento + 
                  " con actividad " + this.props.orden.actividad)
                  : 
                  ((this.props.orden.tramite_id ==="4") ? "Pago de alta de " +
                    this.props.orden.tipo_producto+" para el establecimiento titular "+this.props.orden.nom_establecimiento+" "
                    :((this.props.orden.tramite_id === "6")? "Pago de "+this.props.orden.servicio+" de tipo " + this.props.orden.tipo_constancia 
                      :((this.props.orden.tramite_id === "7")? "Pago de "+this.props.orden.servicio
                       :((this.props.orden.tramite_id === "8")? "Pago de "+this.props.orden.servicio+" de tipo " + this.props.orden.tipo_anotacion +" al producto " +this.props.orden.nombre_comercial
                        :((this.props.orden.tramite_id === "10" || this.props.orden.tramite_id === "12" || this.props.orden.tramite_id === "13" || this.props.orden.tramite_id === "25")?
                        "Pago de "+this.props.orden.servicio+" para la actividad " + this.props.orden.actividad +" del establecimiento " +this.props.orden.razon_social
                          :((this.props.orden.tramite_id === "17")?"Pago de "+this.props.orden.servicio+" por " + this.props.orden.num_certificados +" "+this.props.orden.tipo_tramite
                            :((this.props.orden.tramite_id === "19")?
                            "Pago de " + this.props.orden.cantidad + " " + this.props.orden.servicio + " para el establecimiento: " + this.props.orden.razon_social + " "
                            :"Pago de "+this.props.orden.servicio+" "
                    )))))))
                  }
                  (${this.props.orden.cantidad_num}). 
                </p>
                <p>
                  <b>Fecha: </b>
                  {this.props.date}.
                </p>
                <p
                  style={{ border: "ridge black 1px" }}
                  className="text-center"
                >
                  <b>ESTE DOCUMENTO NO ES UN RECIBO</b>
                </p>
                {/*  <p><b></b></p> */}

                {/*<img style={{ textAlign: "left", margin: "8%" }} src={""} />
                  this.props.orden.firma*/}
                <p style={{ textAlign: "center", margin: "8%" }}>
                  _____________________________________________________
                  <br />
                  Firma y sello IPSA
                </p>
              </form>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ReactToPrint
            content={() => componentRef.current}
            pageStyle=""
            trigger={() => (
              <button className="btn btn-primary m-r-5">Imprimir</button>
            )}
          />
          <button
            className="btn btn-danger"
            onClick={this.props.change}
          >
            Regresar
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default PagoOrden;
